import { apiFetch } from "./apiClient";
import CONFIG from "../config";

export async function listSessions({ scenarioName, limit } = {}) {
  const url = new URL(`${CONFIG.apiUrl}api/sessions`);
  if (scenarioName) url.searchParams.append("scenario_name", scenarioName);
  if (limit) url.searchParams.append("limit", limit.toString());
  const response = await apiFetch(url.toString());
  return response?.sessions || [];
}

export async function getSessionEvents(sessionId) {
  const response = await apiFetch(
    `${CONFIG.apiUrl}api/sessions/${encodeURIComponent(sessionId)}/events`
  );
  return response || [];
}
